import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/Plataforma";
import PlatformGuard from "@/components/plataforma/PlatformGuard";
import { pageHead } from "@/lib/seo";

const GuardedPage = () => (
  <PlatformGuard>
    <Page />
  </PlatformGuard>
);

export const Route = createFileRoute("/plataforma/")({
  head: () =>
    pageHead({
      title: "Plataforma | Método Braussie | Clara Camille",
      description: "Acesse seus guias exclusivos do Método Braussie.",
      path: "/plataforma",
      noindex: true,
    }),
  component: GuardedPage,
});
